import { UserError } from '@sstdev/lib_logging';
class NotLoggedInError extends UserError {
    constructor(delayReason) {
        super('The user is not logged in.  ' + (!delayReason ? '' : 'Delay reason: ' + delayReason));
    }
}

export default NotLoggedInError;
